export const BASE_URL = "https://backend.app20.in";
export const API_BASE_URL = BASE_URL;
